/* unplugin-vue-components disabled */import { render } from "./IntroPersonality.vue?vue&type=template&id=68951883&scoped=true"
import script from "./IntroPersonality.vue?vue&type=script&lang=js"
export * from "./IntroPersonality.vue?vue&type=script&lang=js"

import "./IntroPersonality.vue?vue&type=style&index=0&id=68951883&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68951883"]])

export default __exports__